import { v4 as uuidv4 } from 'uuid'

const newId = () => uuidv4()

export default Object.freeze({ newId })
